on("turbo:load", function () {
	if ($("[data-mark-viewed]").length) {
		setTimeout(function () {
			$("[data-mark-viewed]")[0].requestSubmit();
		}, 3000);
	}
});
